<script>
export default {
  name: "FooterPage"
}
</script>

<template>

  <div dir="rtl" class="">

    <br>
    <br>

    <div class="footer w-100 d-flex justify-content-around align-items-center position-relative">

      <img style="filter: brightness(.3)" src="../../assets/img/footer.svg"
           class="position-absolute img-cover w-100 h-100" alt="">

      <div class="w-20 position-relative z-2 d-flex flex-column justify-content-center align-items-center h-100">
        <img style="width: 7rem;height: 7rem" class="mb-3" src="../../assets/img/logo_welc.svg" alt="">

        <p class="font-6 text-center text-white font-bold">دکوبان ، جامع‌ترین مرکز بازرگانی و خدماتی صنعت ساختمان</p>
      </div>

      <div class="w-20 position-relative z-2 d-flex flex-column justify-content-evenly align-items-center h-100">
        <p class="font-4 font-bold text-white text-center w-100">تماس با ما</p>

        <p class="font-6 font-bold text-white text-center">به راحتی با ما در تماس باشید</p>
        <p class="font-6 font-bold text-white text-center">شماره تماس : 03133766465</p>
        <p class="font-6 font-bold text-white text-center">شماره همراه : 09961999806</p>
        <p class="font-6 font-bold text-white text-center">نشانی : اصفهان - درچه - ساختمان دکوسنتر - طبقه اول</p>
        <p class="font-6 font-bold text-white text-center">Decobancom@Gmail.com</p>
      </div>

      <div class="w-20 position-relative z-2 d-flex flex-column justify-content-evenly align-items-center h-100">
        <p class="font-4 font-bold text-white text-center w-100">دسترسی سریع</p>

        <router-link :to="{name:'ProductsCategory'}" class="font-6 text-decoration-none font-bold text-white text-center item_hover p-2">
          <span>فروشگاه</span>
          <img style="" class="" src="../../assets/img/arrow-left.svg" alt="">
        </router-link>

        <a href="/HomePage#Services" class="font-6 text-decoration-none font-bold text-white text-center item_hover p-2">
          <span>خدمات ما</span>
          <img style="" class="" src="../../assets/img/arrow-left.svg" alt="">
        </a>

        <router-link :to="{name:'SupportPage'}" class="font-6 text-decoration-none font-bold text-white text-center item_hover p-2">
          <span>تماس با ما</span>
          <img style="" class="" src="../../assets/img/arrow-left.svg" alt="">
        </router-link>
      </div>

    </div>
  </div>
</template>

<style scoped>
.footer {
  height: 25rem;
}

.item_hover {
  display: flex;
  justify-content: space-between;
  width: 50%;
  transition: .5s;
  cursor: grab;
}

.item_hover:hover {
  width: 60%;
}
</style>